// src/components/settings/BusinessSettings.jsx
import React, { useState } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";

export default function BusinessSettings() {
  const [images, setImages] = useState({
    whiteLogo: "/assets/img/logo-1.svg",
    darkLogo: "/assets/img/logo-1.svg",
    whiteMini: "/assets/img/logo-1.svg",
    darkMini: "/assets/img/logo-1.svg",
    favicon: "/assets/img/logo-1.svg",
    apple: "/assets/img/logo-1.svg",
  });

  const handleImageChange = (e, key) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setImages((prev) => ({ ...prev, [key]: url }));
    }
  };

  const UploadBox = ({ title, size, imgKey }) => (
    <div className="upload-box">
      <div className="upload-preview">
        <img src={images[imgKey]} alt="" />
      </div>

      <div className="upload-content">
        <h6>{title}</h6>
        <p className="text-muted small">Recommended size is {size}</p>

        <div className="d-flex gap-2">
          <label className="btn btn-sm btn-orange mb-0">
            Change
            <input
              type="file"
              hidden
              onChange={(e) => handleImageChange(e, imgKey)}
            />
          </label>
          <Button
            size="sm"
            variant="light"
            onClick={() =>
              setImages((prev) => ({
                ...prev,
                [imgKey]: "/assets/img/logo-1.svg",
              }))
            }
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="business-settings">
      <h5 className="mb-3">Business Settings</h5>

      {/* BASIC INFO */}
      <div className="section-border">
        <h6>Basic Information</h6>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Company Name</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Email Address</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fax</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Web</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* COMPANY IMAGES */}
      <div className="section-border">
        <h6>Company Images</h6>

        <Row>
          <Col md={6}><UploadBox title="White Logo" size="160px x 50px" imgKey="whiteLogo" /></Col>
          <Col md={6}><UploadBox title="Dark Logo" size="160px x 50px" imgKey="darkLogo" /></Col>

          <Col md={6}><UploadBox title="White Mini Logo" size="80px x 80px" imgKey="whiteMini" /></Col>
          <Col md={6}><UploadBox title="Dark Mini Logo" size="80px x 80px" imgKey="darkMini" /></Col>

          <Col md={6}><UploadBox title="Favicon" size="128px x 128px" imgKey="favicon" /></Col>
          <Col md={6}><UploadBox title="Apple Icon" size="180px x 180px" imgKey="apple" /></Col>
        </Row>
      </div>

      {/* ADDRESS */}
      <div className="section-border">
        <h6>Address Information</h6>

        <Row>
          <Col md={12}>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Country</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>India</option>
                <option>USA</option>
                <option>UK</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>State</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>Telangana</option>
                <option>Andhra Pradesh</option>
                <option>Karnataka</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Select>
                <option>Select</option>
                <option>Hyderabad</option>
                <option>Vijayawada</option>
                <option>Bangalore</option>
              </Form.Select>
            </Form.Group>
          </Col>

          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Postal Code</Form.Label>
              <Form.Control />
            </Form.Group>
          </Col>
        </Row>
      </div>

      {/* ACTIONS */}
      <div className="text-end">
        <Button variant="light">Cancel</Button>
        <Button className="btn-orange ms-2">Save</Button>
      </div>
      <style>
          {
               `
               .section-border {
  border: 1px solid #e5e7eb;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  background: #fff;
}

.section-border h6 {
  font-weight: 600;
  margin-bottom: 15px;
}

.upload-box {
  display: flex;
  gap: 15px;
  border: 1px solid #eee;
  padding: 15px;
  border-radius: 6px;
  background: #fafafa;
  align-items: center;
  margin-bottom: 15px;
}

.upload-preview {
  width: 70px;
  height: 70px;
  border: 1px dashed #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
}

.upload-preview img {
  max-width: 100%;
  max-height: 100%;
}

.upload-content h6 {
  margin-bottom: 4px;
  font-size: 14px;
}

.btn-orange {
  background: #ff6a00;
  border: none;
  color: #fff;
}

.btn-orange:hover {
  background: #e65c00;
}

.business-settings input,
.business-settings select {
  height: 40px;
  font-size: 14px;
}

/* MOBILE RESPONSIVE */
@media (max-width: 768px) {
  .upload-box {
    flex-direction: column;
    align-items: flex-start;
  }

  .upload-preview {
    width: 100%;
    height: 80px;
  }
}`
          }
      </style>
    </div>
  );
}